import { render } from "./TravelRoutes.vue?vue&type=template&id=e37701ae&scoped=true"
import script from "./TravelRoutes.vue?vue&type=script&lang=js"
export * from "./TravelRoutes.vue?vue&type=script&lang=js"

import "./TravelRoutes.vue?vue&type=style&index=0&id=e37701ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e37701ae"]])

export default __exports__